import React, { FunctionComponent, useCallback, useEffect } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme';

import { ModalConfirmPure } from '../../../../../../shared/components/modal-confirm';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useSummarizationMailRecipientCheckboxState } from '../../hooks/use-summarization-mail-recipient-checkbox-state';
import { SummarizationMailRecipientCheckbox } from '../summarization-mail-recipient-checkbox';
import { SummarizationModalProps } from '../types';

export const SummarizationStopModal: FunctionComponent<SummarizationModalProps> = ({ onClose: closeHandler }) => {
    const [checkboxState, setCheckboxState] = useSummarizationMailRecipientCheckboxState();

    useEffect(() => countMetrika('meeting_screen', 'summarization', 'stop_popup_was_shown'), []);

    const onConfirm = () =>
        closeHandler?.({
            isConfirmed: true,
            isSummarizationMailForParticipants: checkboxState.isSelected,
        });
    const onCancel = () => closeHandler?.({ isConfirmed: false });

    const onCheckboxChange = useCallback(
        (isSelected: boolean) => {
            setCheckboxState({
                isSelected,
            });
        },
        [setCheckboxState]
    );

    return (
        <ScopedTheme theme="dark">
            <ModalConfirmPure
                visible={true}
                onClose={onCancel}
                onCancel={onCancel}
                onConfirm={onConfirm}
                title={i18n('summarization', 'stop-dialog-title')}
                cancelLabel={i18n('summarization', 'stop-dialog-deny-v2')}
                confirmLabel={i18n('summarization', 'stop-dialog-submit-v2')}
            >
                {i18n('summarization', 'stop-dialog-content-v2')}
                <SummarizationMailRecipientCheckbox {...checkboxState} onChange={onCheckboxChange} />
            </ModalConfirmPure>
        </ScopedTheme>
    );
};
